import { debounce } from '../utils';

jQuery(($) => {
  if (!$('body').hasClass('page-template-hiring-center_archive')) {
    return;
  }

  const $postPreviewContainers = $('.fade-reveal__post-preview');

  const $searchInputs = $postPreviewContainers
    .filter(function getSearchEnabledPreviewContainers() {
      return $(this).data('searchEnabled');
    })
    .find('input[id$=fade_reveal_search]');

  const clearFilters = () => {
    $('button.hiring-center-section-filter').removeClass('active');
    $('.fade-reveal__post-preview').show();
  };

  $('button.hiring-center-section-filter').on('click', function handleHiringCenterSectionFilterClick() {
    const $btn = $(this);
    const selectedSection = $btn.text().trim();
    const isCurrentlyActive = $btn.hasClass('active');

    // Remove active class from all buttons
    $('button.hiring-center-section-filter').removeClass('active');

    if (!isCurrentlyActive) {
      $btn.addClass('active');
      $postPreviewContainers.each(function handleSectionFilter() {
        const $container = $(this);
        const sectionTitle = $container.find('.fade-reveal__title').text().trim();
        if (sectionTitle !== selectedSection) {
          $container.hide();
        } else {
          $container.show();
        }
      });
    } else {
      // If clicking the already active button, clear all filters
      clearFilters();
    }
  });

  function handleHiringHubSearch(e) {
    const { value = '' } = e.target;
    $searchInputs.each(function triggerSearch() {
      $(this).val(value);
      const event = new KeyboardEvent('keypress', {
        key: 'Enter',
        code: '13',
        bubbles: true,
        cancelable: true,
      });
      event.originatedFromHiringHubSearchHandler = true;
      this.dispatchEvent(event);
      $(this).val('');
    });
  }

  // clear the hiring hub search input if a user interacts
  // with an individual input while there is a value in the hiring hub search input
  function handleIndividualSearch(e) {
    if (!$('#hiringcenter-search').val()) {
      return;
    }
    $('#hiringcenter-search').val('');

    const $currentInput = $(e.target);

    $searchInputs.each(function resetOtherContainers() {
      const $input = $(this);
      if ($input[0] === $currentInput[0]) {
        return;
      }

      $input.val('');
      $input[0].dispatchEvent(new KeyboardEvent('keypress', {
        key: 'Enter',
        code: '13',
        bubbles: true,
        cancelable: true,
      }));
    });
  }

  $('#hiringcenter-search').on('input', debounce(handleHiringHubSearch, 500));

  $searchInputs.on('keypress', (e) => {
    if ((e.key === 'Enter' || e.code === 13) && !e.originalEvent.originatedFromHiringHubSearchHandler) {
      handleIndividualSearch(e);
    }
  });
});
